export default __webpack_public_path__ + "static/media/linked-in-icon.0ef231e7.svg";